@if (tMetricGroups().length > 0) {
  <div class="metrics-container">
    @for (group of tMetricGroups(); track group.taskName) {
      <div class="task-group" [attr.data-task]="group.taskId">
        <!-- Task Title -->
        <div class="task-title-row">
          <cb-task-icon-button
            [icon]="getTaskIcon(group.taskId)"
            [taskId]="group.taskId"
            [projectId]="cbProject()?._id || ''"
            (iconChange)="onTaskIconChange(group.taskId, $event)"
          />
          <h2 class="task-title">{{ group.taskName }}</h2>
        </div>

        <!-- Metrics Rows -->
        @for (metric of group.metrics; track metric.uid; let i = $index) {
          <div class="metric-row" @metricAnimation>
            <!-- Metric Name Input -->
            <div class="metric-name-input-container">
              <input
                type="text"
                class="metric-name-input"
                [class.error]="duplicateMetricUids().has(metric.uid)"
                [value]="metric.name"
                (input)="onNameChange(getMetricIndex(group.taskId, i), $any($event.target).value)"
                placeholder="Metric name"
              />
              @if (group.metrics.length > 1) {
                <oph-x-button
                  class="remove-button x-button-small-screen"
                  [width]="24"
                  (buttonClick)="removeMetric(getMetricIndex(group.taskId, i))"
                ></oph-x-button>
              }
            </div>
            <!-- Type Selector -->
            <button type="button" class="select-button type-button" [matMenuTriggerFor]="typeMenu">
              {{ getTypeDisplay(metric.type) }}
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </button>
            <mat-menu #typeMenu="matMenu" class="oph-select-menu">
              @for (typeOption of metricTypeOptions; track typeOption.value) {
                <button
                  type="button"
                  (click)="onTypeChange(getMetricIndex(group.taskId, i), typeOption.value)"
                  class="oph-select-menu-item"
                >
                  {{ typeOption.display }}
                </button>
              }
            </mat-menu>

            <!-- Type Option Selector (conditional based on type) -->
            <button
              type="button"
              class="select-button type-option-button"
              [class.hidden]="!shouldShowTypeOption(metric.type)"
              [matMenuTriggerFor]="typeOptionMenu"
            >
              {{ getTypeOptionDisplay(metric) }}
              <mat-icon svgIcon="chevron-down"></mat-icon>
            </button>
            <mat-menu #typeOptionMenu="matMenu" class="oph-select-menu">
              @for (suffixOption of getSuffixOptionsForType(metric.type); track suffixOption.value) {
                <button
                  type="button"
                  (click)="onTypeOptionChange(getMetricIndex(group.taskId, i), suffixOption.value)"
                  class="oph-select-menu-item"
                >
                  {{ suffixOption.display }}
                </button>
              }
            </mat-menu>

            <!-- X Button -->
            @if (group.metrics.length > 1) {
              <oph-x-button
                class="remove-button x-button-large-screen"
                [width]="24"
                (buttonClick)="removeMetric(getMetricIndex(group.taskId, i))"
              ></oph-x-button>
            }
          </div>
        }

        <!-- Add Metric Button -->
        <button type="button" class="add-metric-button" (click)="addMetric(group.taskId)">
          <div class="plus-icon">
            <mat-icon svgIcon="plus"></mat-icon>
          </div>
        </button>
      </div>
    }
  </div>
}
